import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import { Box } from '@mui/material';
import { Button, Form, Tooltip } from 'antd';
import Notification01Icon from 'assets/icons/notification01Icon';
import { useLocation } from 'react-router-dom';
import { useMemo, useState, useEffect } from 'react';
import DataTable from 'components/LynDataTable/DataTable';
import { formatNumber, utcConverter } from '../utils/helperFunc';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import ConfirmModal from 'components/modal/ConfirmModal';
import LeaseRecordViewModal from '../../../lease-v9/lease-record-management-v9/CustomComponents/LeaseRecordViewModal';

const styles = `
  .active .MuiTableCell-root:first-of-type {
    background-color: inherit !important;
  }
`;

const LeaseEditScheduleTable = ({ leaseControlData = [], queryV3Loader, viewData }) => {
	const { state } = useLocation();

	const form = Form.useFormInstance();

	const leaseId = form.getFieldValue('leaseId');
	const leaseType = form.getFieldValue('leaseType');

	const [getActionRequiredData] = useSendControlDataMutation();
	const [getJournalEntryData, { data: journalEntryData, isLoading: isJournalEntryDataLoading }] = useSendControlDataMutation();

	const [rowId, setRowId] = useState(null);
	const [showJournalEntryModal, setShowJournalEntryModal] = useState(false);
	const [tableUpperLeftExtraInfo, setTableUpperLeftExtraInfo] = useState({});
	const [isActionColumnShowAllow, setIsActionColumnShowAllow] = useState(false);
	const [actionRequiredConfirmModal, setActionRequiredConfirmModal] = useState(false);

	useEffect(() => {
		const styleElement = document.createElement('style');

		styleElement.innerHTML = styles;

		document.head.appendChild(styleElement);

		return () => {
			document.head.removeChild(styleElement);
		};
	}, []);

	const handleEyeButton = async (row) => {
		const index = row.id;

		setTableUpperLeftExtraInfo({
			leaseId,
			leaseTitle: form.getFieldValue('leaseTitle'),
			leasePeriod: index + 1,
		});

		const formData = form.getFieldsValue(true);
		// const changes = formData?.changes?.slice(1, formData?.changes?.length);
		const changes = formData?.changes?.slice(1, formData?.changes?.length);

		const calculateData = {
			changes: changes,

			grossRent: 0,
			escalation: 0,
			// leaseTerm: formData?.leaseTerm,
			paymentTime: formData?.changes?.[0]?.paymentTime,
			leaseTerm: formData?.changes?.[0]?.inputChangeLeaseTerm,
			grossRents: formData?.changes?.[0]?.inputChangeGrossRents,
			paymentFrequency: formData?.changes?.[0]?.paymentFrequency,
			advanceAmount: formData?.changes?.[0]?.inputChangeAdvance,
			advanceAmounts: formData?.changes?.[0]?.inputChangeAdvanceAmounts,
			discountRate: formData?.changes?.[0]?.inputChangeDiscountRate,
			endOfFinancialYear: formData?.endOfFinancialYear,
			startDay: String(formData?.leaseStartDate?.date()),
			startYear: String(formData?.leaseStartDate?.year()),
			initialDirectCost: String(formData?.changes?.[0]?.initialDirectCost),
			securityDeposit: String(formData?.changes?.[0]?.securityDeposit),
			startMonth: String(formData?.leaseStartDate?.month() + 1),
			upfrontLeasePayment: String(formData?.changes?.[0]?.upfrontLeasePayment),
			cashIncentiveAmount: String(formData?.changes?.[0]?.cashIncentiveAmount ?? 0),
			advanceDuration: formData?.changes?.[0]?.advanceAmounts?.filter((item) => item !== 0)?.length,
		};
		// const calculateData = {
		// 	changes: changes,
		// 	grossRent: 0,
		// 	escalation: 0,
		// 	leaseTerm: formData?.leaseTerm_new,
		// 	grossRents: formData?.grossRents_new,
		// 	paymentTime: formData?.paymentModality_new,
		// 	advanceAmount: formData?.advanceAmount_new,
		// 	advanceAmounts: formData?.advanceAmounts_new,
		// 	discountRate: formData?.initialDiscountRate_new,
		// 	endOfFinancialYear: formData?.endOfFinancialYear,
		// 	paymentFrequency: formData?.paymentFrequency_new,
		// 	startDay: String(formData?.leaseStartDate?.date()),
		// 	startYear: String(formData?.leaseStartDate?.year()),
		// 	initialDirectCost: String(formData?.initialDirectCost),
		// 	securityDeposit: String(formData?.securityDeposit_new),
		// 	startMonth: String(formData?.leaseStartDate?.month() + 1),
		// 	upfrontLeasePayment: String(formData?.upfrontLeasePayment_new),
		// 	cashIncentiveAmount: String(formData?.cashIncentiveAmount_new ?? 0),
		// 	advanceDuration: formData?.advanceAmounts_new?.filter((item) => item !== 0)?.length,
		// };

		const identityData = {
			...formData,
			grossRent: 0,
			escalation: 0,
			leaseType: formData?.leaseType,
			tempLeaseId: formData?.leaseId,
			lessorName: formData?.lessorName,
			leaseTerm: formData?.leaseTerm_new,
			grossRents: formData?.grossRents_new,
			leaseTitle: formData?.leaseTitle_new,
			lastModifiedDate: utcConverter(dayjs()),
			modifiedDateTime: utcConverter(dayjs()),
			grossRentList: formData?.grossRentList_new,
			advanceAmounts: formData?.advanceAmounts_new,
			grossRentListSet: formData?.grossRentListSet,
			advanceAmount: formData?.advanceAmount_new,
			paymentModality: formData?.paymentModality_new,
			paymentFrequency: formData?.paymentFrequency_new,
			advanceAmountList: formData?.advanceAmountList_new,
			advanceAmountListSet: formData?.advanceAmountListSet,
			leaseStartDate: utcConverter(formData?.leaseStartDate),
			leaseEndDate: utcConverter(formData?.leaseEndDate_new),
			initialDiscountRate: formData?.initialDiscountRate_new,
			initialDirectCost: String(formData?.initialDirectCost),
			securityDeposit: String(formData?.securityDeposit_new),
			endOfFinancialYear: utcConverter(formData?.endOfFinancialYear),
			upfrontLeasePayment: String(formData?.upfrontLeasePayment_new),
			cashIncentiveAmount: String(formData?.cashIncentiveAmount_new ?? 0),
			advanceDuration: formData?.advanceAmounts_new?.filter((item) => item !== 0)?.length,
			paymentModalityLabel: formData?.paymentModality_new?.toLowerCase() === 'start' ? 'Advance basis' : 'Acrual Basis',
			changes: formData?.changes?.map((item) => {
				return {
					...item,
					inputChangeGrossRents: formData?.grossRents_new,
					inputChangeAdvanceAmounts: formData?.advanceAmounts_new,
					securityDeposit: String(formData?.securityDeposit_new ?? 0),
					initialDirectCost: String(formData?.securityDeposit_new ?? 0),
					cashIncentiveAmount: String(formData?.cashIncentiveAmount_new ?? 0),
					upfrontLeasePayment: String(formData?.upfrontLeasePayment_new ?? 0),
					inputChangeAdvance: formData?.advanceAmounts_new?.reduce((acc, curr) => acc + curr, 0),
				};
			}),
		};

		const payloadData = {
			identityData,
			calculateData,
			calculate: true,
			scheduledIndex: index + 1,
		};

		const convertJson = JSON.stringify(payloadData);
		const convertBase64 = btoa(convertJson);
		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-schedule-findata2',
			payloadData: payloadData,
		};

		try {
			setTimeout(() => {
				setShowJournalEntryModal(true);
			}, 500);
			await getJournalEntryData(formattedPayload);
		} catch (error) {
			console.error('Error in handleEyeButton:', error);
		}
	};

	const handleActionRequiredButton = async () => {
		const payloaddata = {
			id: rowId,
		};
		const convertJson = JSON.stringify(payloaddata);
		const convertBase64 = btoa(convertJson);
		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-schedule-ready',
			payloadData: payloaddata,
		};

		try {
			await getActionRequiredData(formattedPayload);
			// Refresh the lease schedule data after action is completed
			if (typeof queryV3Loader === 'function') {
				await queryV3Loader(true);
			}
		} catch (error) {
			console.error('Error in handleActionRequiredButton:', error);
		}
	};

	const columnData = useMemo(() => {
		if (leaseType === 'Operating Lease') {
			return [
				{
					id: 'date',
					width: '5%',
					align: 'center',
					accessor: 'date',
					cellAlign: 'center',
					Header: 'Date',
				},
				{
					id: 'period',
					width: '5%',
					align: 'center',
					accessor: 'period',
					cellAlign: 'center',
					Header: 'Period',
				},
				{
					id: 'grossRent',
					width: '5%',
					align: 'center',
					accessor: 'grossRent',
					cellAlign: 'center',
					Header: 'Gross Pay',
				},
				{
					id: 'advanceAmount',
					width: '5%',
					align: 'center',
					accessor: 'advanceAmount',
					cellAlign: 'center',
					Header: 'Advance',
				},
				{
					id: 'netPay',
					width: '5%',
					align: 'center',
					accessor: 'netPay',
					cellAlign: 'center',
					Header: 'Net Pay',
				},
				{
					id: 'payment',
					width: '5%',
					align: 'right',
					accessor: 'payment',
					cellAlign: 'right',
					Header: 'Payment',
				},
				...(isActionColumnShowAllow
					? [
							{
								Header: 'Action',
								Cell: (cell) => {
									// Only show the Action Required button when needed
									if (cell?.row?.original?.processStatus?.toLowerCase() === 'returned') {
										return (
											<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
												<div style={{ textAlign: 'center' }}>
													<Tooltip title="Action Required">
														<Button
															type="text"
															icon={<Notification01Icon width={16} height={16} color="#B00020" />}
															onClick={(e) => {
																e.stopPropagation();
																setRowId(cell?.row?.original?._id);
																setActionRequiredConfirmModal(true);
															}}
														></Button>
													</Tooltip>
												</div>
											</Box>
										);
									}
									// Return null if no action is needed
									return null;
								},
								disableSortBy: 'true',
								align: 'center',
							},
						]
					: []),
			];
		} else {
			return [
				{
					id: 'date',
					width: '5%',
					align: 'center',
					accessor: 'date',
					cellAlign: 'center',
					Header: 'Date',
				},
				{
					id: 'period',
					width: '5%',
					align: 'center',
					accessor: 'period',
					cellAlign: 'center',
					Header: 'Period',
				},
				{
					id: 'grossRent',
					width: '5%',
					align: 'center',
					accessor: 'grossRent',
					cellAlign: 'center',
					Header: 'Gross Pay',
				},
				{
					id: 'advanceAmount',
					width: '5%',
					align: 'center',
					accessor: 'advanceAmount',
					cellAlign: 'center',
					Header: 'Advance',
				},
				{
					id: 'netPay',
					width: '5%',
					align: 'center',
					accessor: 'netPay',
					cellAlign: 'center',
					Header: 'Net Pay',
				},

				{
					id: 'ibr',
					width: '5%',
					align: 'center',
					accessor: 'ibr',
					cellAlign: 'center',
					Header: 'IBR (%)',
				},

				{
					id: 'discountFactor',
					width: '5%',
					align: 'center',
					accessor: 'discountFactor',
					cellAlign: 'center',
					Header: 'Discount Factor',
				},

				{
					id: 'rentExp',
					width: '5%',
					align: 'center',
					accessor: 'rentExp',
					cellAlign: 'center',
					Header: 'PV of Rent',
				},

				{
					id: 'openLeaseLiability',
					width: '5%',
					align: 'right',
					accessor: 'openLeaseLiability',
					cellAlign: 'right',
					Header: 'Open Lease Liability',
				},
				{
					id: 'adjustment',
					width: '5%',
					align: 'right',
					accessor: 'adjustment',
					cellAlign: 'right',
					Header: 'Adjustment',
				},
				{
					id: 'interestExp',
					width: '5%',
					align: 'right',
					accessor: 'interestExp',
					cellAlign: 'right',
					Header: 'Interest Expense',
				},
				{
					id: 'payment',
					width: '5%',
					align: 'right',
					accessor: 'payment',
					cellAlign: 'right',
					Header: 'Payment',
				},

				{
					id: 'closingLeaseLiability',
					width: '5%',
					align: 'right',
					accessor: 'closingLeaseLiability',
					cellAlign: 'right',
					Header: 'Closing Lease Liability',
				},
				{
					id: 'principal',
					width: '5%',
					align: 'right',
					accessor: 'principal',
					cellAlign: 'right',
					Header: 'Principal',
				},
				{
					id: 'cllfye',
					width: '5%',
					align: 'right',
					accessor: 'cllfye',
					cellAlign: 'right',
					Header: 'Current Lease Liability Financial Year End',
				},
				{
					id: 'cllr12',
					width: '5%',
					align: 'right',
					accessor: 'cllr12',
					cellAlign: 'right',
					Header: 'Current Lease Liability (Rolling 12)',
				},
				{
					id: 'ncllfye',
					width: '5%',
					align: 'right',
					accessor: 'ncllfye',
					cellAlign: 'right',
					Header: 'Non-Current Lease Liability Financial Year End',
				},
				{
					id: 'ncllr12',
					width: '5%',
					align: 'right',
					accessor: 'ncllr12',
					cellAlign: 'right',
					Header: 'Non-Current Lease Liability (Rolling 12)',
				},
				...(isActionColumnShowAllow
					? [
							{
								Header: 'Action',
								Cell: (cell) => {
									// Only show the Action Required button when needed
									if (cell?.row?.original?.processStatus?.toLowerCase() === 'returned') {
										return (
											<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
												<div style={{ textAlign: 'center' }}>
													<Tooltip title="Action Required">
														<Button
															type="text"
															icon={<Notification01Icon width={16} height={16} color="#B00020" />}
															onClick={(e) => {
																e.stopPropagation();
																setRowId(cell?.row?.original?._id);
																setActionRequiredConfirmModal(true);
															}}
														></Button>
													</Tooltip>
												</div>
											</Box>
										);
									}
									// Return null if no action is needed
									return null;
								},
								disableSortBy: 'true',
								align: 'center',
							},
						]
					: []),
			];
		}
	}, [isActionColumnShowAllow, leaseType]);

	const tableData = Array.isArray(leaseControlData)
		? leaseControlData?.map((item, index) => ({
				...item,
				date: dayjs(item.date).format('YYYY-MM-DD'),
				id: index,
				period: item?.period,
				grossRent: formatNumber(item.grossRent, 2),
				discountFactor: formatNumber(item.discountFactor, 4),
				rentExp: formatNumber(item.rentExp, 2),
				interestExp: formatNumber(item.interestExp, 2),
				openLeaseLiability: formatNumber(item.openLeaseLiability, 2),
				interest: formatNumber(item.interest, 2),
				payment: formatNumber(item.payment, 2),
				closingLeaseLiability: formatNumber(item.closingLeaseLiability, 2),
				adjustment: formatNumber(item.adjustment, 2),
				advanceAmount: formatNumber(item.advanceAmount, 2),
				netPay: formatNumber(item.netPay, 2),
				ibr: formatNumber(item.ibr, 2),
				principal: formatNumber(item.principal, 2),
				cllfye: formatNumber(item.cllfye, 2),
				cllr12: formatNumber(item.cllr12, 2),
				ncllfye: formatNumber(item.ncllfye, 2),
				ncllr12: formatNumber(item.ncllr12, 2),
			}))
		: [];

	const ModalData = {
		head: 'Returned Lease - Required Action',
	};

	const rowIndexColorMapping = useMemo(() => {
		const statusColorMap = {
			Pending: '#E6F0FF', // light blue
			// Pending: 'red', // light blue
			Unprocessed: '#E6F0FF', // light blue
			Reversed: '#ffcccc', // light red
			Returned: '#FFFDE6', // light yellow
			Recorded: '#E6FFE6', // light green
			Processed: '#E6F0FF', // light blue
		};

		let newMapping = {};

		Array.isArray(leaseControlData) &&
			leaseControlData?.forEach((lease, index) => {
				if (lease.processStatus) {
					if (lease.processStatus.toLowerCase() === 'returned') {
						setIsActionColumnShowAllow(true);
					}

					if (!isEmpty(viewData?.refCCAssignmentIdentityId) && !isEmpty(viewData?.refCCAssignmentIdentityId)) {
						newMapping[index] = {
							rowColor: statusColorMap[lease.processStatus] || '#FCFCFC',
						};
					}
				}
			});

		return newMapping;
	}, [leaseControlData]);

	return (
		<>
			{Array.isArray(tableData) && tableData?.length !== 0 && (
				<DataTable
					pagination={false}
					DATA={tableData || []}
					firstColStrick={false}
					COLUMNS={columnData || []}
					pageSize={tableData.length}
					xlsxFileName={`${leaseId}_date`}
					rowIndexColorMapping={rowIndexColorMapping}
					onClickHandler={(row) => handleEyeButton(row)}
					defaultVisibleColumn={['principal', 'cllfye', 'cllr12', 'ncllfye', 'ncllr12']}
				/>
			)}

			{showJournalEntryModal && (
				<LeaseRecordViewModal
					showModal={showJournalEntryModal}
					setShowModal={setShowJournalEntryModal}
					isDataLoading={isJournalEntryDataLoading}
					tableUpperLeftExtraInfo={tableUpperLeftExtraInfo}
					checkResponseData={journalEntryData?.responseData || []}
				/>
			)}

			{actionRequiredConfirmModal && (
				<ConfirmModal
					modalData={ModalData}
					showModal={actionRequiredConfirmModal}
					handleSubmit={handleActionRequiredButton}
					setShowModal={setActionRequiredConfirmModal}
				/>
			)}
		</>
	);
};

export default LeaseEditScheduleTable;
